import { render, staticRenderFns } from "./SalesScoreDiscountModal.vue?vue&type=template&id=d5a89a28&"
import script from "./SalesScoreDiscountModal.vue?vue&type=script&lang=js&"
export * from "./SalesScoreDiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports